//@vendor
const get = require('lodash/object/get');
//@constants
const actionTypes = require('constants/actionTypes');
const { FIRST_STEP } = require('constants/index');
//@actions
const signaturePatternActions = require('actions/signaturePattern');
//@utilities
const { APIGet, APIPost } = require('utilities/APIRequestHelper');

const setUpStep = operationType => (dispatch, getState) => {
    const immCardModifyDebitLimits = getState().cardModifyDebitLimits;
    const immLimits = immCardModifyDebitLimits.getIn(['debitLimits', operationType]);

    dispatch ({
        type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_SETUP_STEP,
        payload: {
            operationType,
            currentLimit: immLimits.get('currentLimit'),
            currency: immLimits.get('currency'),
        }
    })
};

const reset = () => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_RESET,
});

const setLimit = limit => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_SET_LIMIT,
    payload: {
        limit
    }
});

const setVisibleStep = step => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillCancel = willCancel => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_SET_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const validateStep = step => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_VALIDATE_STEP,
    payload: {
        step
    }
});

const cardModifyDebitLimitsFetchRequest = () => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_FETCH_REQUEST
});

const cardModifyDebitLimitsFetchSuccess = (response, commerceCurrentLimit, extractCurrentLimit) => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_FETCH_SUCCESS,
    payload: {
        response,
        commerceCurrentLimit,
        extractCurrentLimit
    }
});

const cardModifyDebitLimitsFetchFailure = error => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_FETCH_FAILURE,
    payload: {
        error
    }
});

const cardModifyDebitLimitsSubmitRequest = () => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_SUBMIT_REQUEST
});

const cardModifyDebitLimitsSubmitSuccess = response => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_SUBMIT_SUCCESS,
    payload: {
        response
    }
});

const cardModifyDebitLimitsSubmitFailure = error => ({
    type: actionTypes.CARD_MODIFY_DEBIT_LIMITS_SUBMIT_FAILURE,
    payload: {
        error
    }
});

const requestLimits = (cardId, operationType) => (dispatch, getState) => {
    const immCard =  getState().cards.getIn(['byId', cardId]);
    const commerceCurrentLimit = immCard.get('limitCommerce');
    const extractCurrentLimit = immCard.get('limitExtract');

    const params = {
        query: {
            tipo: immCard.get('newProduct'),
            subtipo: immCard.get('productSubType'),
            standard: immCard.getIn(['criteria', 'c1', 'estand'])
        }
    };

    dispatch(cardModifyDebitLimitsFetchRequest());
    return APIGet({ dispatch, endpoint: 'hireCards', params })
    .then(response => {
        if (get(response, 'result.msg', '') === 'OK') {
            dispatch(cardModifyDebitLimitsFetchSuccess(response, commerceCurrentLimit, extractCurrentLimit));
            dispatch(setUpStep(operationType));
        } else {
            dispatch(cardModifyDebitLimitsFetchFailure('error'));
        }
    })
    .catch(response => {
        if(!!response.error) {
            dispatch(cardModifyDebitLimitsFetchFailure(response.error));
        } else {
            throw response;
        }
    });
};

const modifyDebitLimits = (cardId) => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immCardModifyDebitLimits = getState().cardModifyDebitLimits;
        const immStepOne = immCardModifyDebitLimits.getIn(['steps', FIRST_STEP]);

        const params = {
            query: {
                dataToken,
                codigoLimite: immCardModifyDebitLimits.get('operationType'),
                divisaNuevoLimite: immStepOne.get('currency'),
                importeNuevoLimite: immStepOne.get('limit'),
                numeroContrato: immCard.getIn(['contract', 'number']),
                pan: immCard.get('number'),
                producto: immCard.getIn(['contract', 'product']),
                standard: immCard.getIn(['product', 'standard']),
                subtipo: immCard.getIn(['product', 'subtype']),
            }
        };

        dispatch(cardModifyDebitLimitsSubmitRequest());
        return APIPost({ dispatch, endpoint: 'cardModifyDebitLimits', params })
            .then(response => {
                dispatch(cardModifyDebitLimitsSubmitSuccess(response));
            })
            .catch(response => {
                if(!!response.error) {
                    dispatch(cardModifyDebitLimitsSubmitFailure(response.error.description));
                } else {
                    throw response;
                }
            });
    };

    new Promise(function () {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    })
};

module.exports = {
    setLimit,
    reset,
    setVisibleStep,
    setWillCancel,
    validateStep,
    modifyDebitLimits,
    requestLimits,
};
